export default __webpack_public_path__ + "static/media/cha robh.b0235f9f.mp3";